import React, { useEffect, useState } from 'react'
import CIcon from '@coreui/icons-react'
import { cilSearch } from '@coreui/icons';
import {
    CFormLabel,
    CFormInput,
    CInputGroup,
    CInputGroupText
} from '@coreui/react'

const InputField = ({ formik, nombre, etiqueta, tipoDato, placeHolder, helperValidation, type = 'text', className = '', disabled = true, readOnly = false, groupButtons, handleBlur = () => { } }) => {

    return (
        <div className="mb-3">
            {etiqueta && (<CFormLabel htmlFor={nombre}>{etiqueta.toUpperCase()}</CFormLabel>)}
            <CInputGroup>
                <CFormInput
                    id={nombre}
                    name={nombre}
                    placeholder={placeHolder}
                    type={type}
                    className={
                        !formik.touched[nombre]
                            ? ` ${className}`
                            : formik.errors[nombre]
                                ? `is-invalid ${className}`
                                : ` ${className}`
                    }
                    onChange={(e) => {
                        let val = e.target.value;
                        if (tipoDato === 'String') {
                            val = val.toUpperCase();
                        }
                        formik.setFieldValue(nombre, val);
                    }}
                    onBlur={handleBlur}
                    value={formik.values[nombre] || ''}
                    readOnly={readOnly}
                    onKeyPress={helperValidation}
                    disabled={!disabled}
                    autoComplete="off"
                />
                {groupButtons}
                {formik.errors[nombre] && <div className="invalid-feedback">{formik.errors[nombre]}</div>}
            </CInputGroup>
        </div>
    )
}

export default InputField;